// Libraries
import React, { createRef } from 'react';
import PropTypes from 'prop-types';

// Utilities
import { defaultLanguage } from 'i18n';

// Components
import ReportChart from 'admin/engagement/reporting/components/NumericQuestionReport/ReportChart';
import ResponseAnalysis from 'admin/engagement/reporting/components/OpenBudgetQuestionReport/ResponseAnalysis';

const OpenBudgetInputChart = ({ data, analysis, comparisonValueLabel }) => {
  const chartRef = createRef();
  const {
    input: {
      id,
      labelTranslations,
      displayData: { comparisonValue },
    },
    breakdown,
  } = data;
  const analysisResult = analysis.find((obj) => obj.id === id);
  if (analysisResult) analysisResult.comparisonValue = comparisonValue;

  return (
    <div>
      <hr />
      <h3 className="title is-6">{labelTranslations[defaultLanguage]}</h3>
      <ReportChart data={breakdown} chartRef={chartRef} />
      <br />
      {analysisResult && (
        <ResponseAnalysis data={analysisResult} comparisonValueLabel={comparisonValueLabel} />
      )}
      <br />
    </div>
  );
};

OpenBudgetInputChart.propTypes = {
  data: PropTypes.shape({
    input: PropTypes.shape({
      id: PropTypes.number,
      labelTranslations: PropTypes.shape({
        en: PropTypes.string,
      }),
      displayData: PropTypes.shape({
        comparisonValue: PropTypes.string,
      }),
    }),
    breakdown: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  analysis: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    })
  ).isRequired,
  comparisonValueLabel: PropTypes.string.isRequired,
};

export default OpenBudgetInputChart;
